import {
    SOCIAL_LOGIN_REQUEST,
    SOCIAL_LOGIN_SUCCESS,
    SOCIAL_LOGIN_FAILURE,
} from '../constant/actionTypes';

const initState = {
    list: {
        isLoading: false,
        pagination: {},
        data: []
    },
    submitResponse: {
        isSubmitting: false,
        data: {}
    },
    user: {}
}

const socialLogin = (state = initState, action) => {
    switch (action.type) {

        case SOCIAL_LOGIN_REQUEST:
            return {
                ...state,
                me: {},
                submitResponse: {
                    data: {},
                    isSubmitting: true
                }
            };
        case SOCIAL_LOGIN_SUCCESS:
            return {
                ...state,
                me: action.payload,
                isLogged: true,
                refreshFailed: false,
                tokenExpired: false,
                submitResponse: {
                    data: action.payload,
                    isSubmitting: false
                }
            };
        case SOCIAL_LOGIN_FAILURE:
            return {
                ...state,
                isLogged: false,
                submitResponse: {
                    data: action.payload,
                    isSubmitting: false
                }
            };
        default:
            return state;
    }
}

export default socialLogin;